<template>
  <WsUpdate
    ref="wsUpdate"
    :modelName="modelName"
    :submodelName="submodelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :titleKey="'last_version.name'"
    editType="updateVersion"
  >
  </WsUpdate>
</template>

<script>
import actModel from "@/models/act";
import subModel from "@/models/article";
export default {
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.app.needSave) {
      const ans = window.confirm("確認捨棄目前編輯內容嗎？");
      if (ans) {
        this.$store.dispatch("app/stopNeedSave");
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data: () => ({
    modelName: actModel.modelName,
    submodelName: subModel.modelName,
    label: actModel.label,
    fields: actModel.fields.last_version.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "法規內容",
              fields: ["locales", "announce_at", "effect_at", "reference_link"],
            },
          ],
        },
      ],
    },
  }),
};
</script>